import { Checkbox } from '@assembly-js/design-system';
import React from 'react';

interface CheckboxCellRendererProps {
  isSelected: boolean;
  onToggle: () => void;
}

const CHECKBOX_CLASSES = { root: 'bulk-ds-checkbox' };

const CheckboxCellRenderer: React.FC<CheckboxCellRendererProps> = ({
  isSelected,
  onToggle,
}) => {
  const handleCellClick = React.useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <div
      className={`bulk-checkbox-cell ${
        isSelected ? 'bulk-checkbox-checked' : ''
      }`}
      onClick={handleCellClick}
      onDoubleClick={handleCellClick}
    >
      <Checkbox
        label=""
        checked={isSelected}
        onChange={onToggle}
        classes={CHECKBOX_CLASSES}
      />
    </div>
  );
};

export default CheckboxCellRenderer;
